//import hooks
import { useTranslation } from "react-i18next";

// import components
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

// import assets
import "../assets/css/footer.css";
import oceanLogo from "../assets/img/ocean.png";

import appstore from "../assets/svg-icons/appstore.svg";
import playstore from "../assets/svg-icons/googleplay.svg";

// import data
import socialData from "../utils/data/socialData";
import footerLinks from "../utils/data/footerLinks";
import contactData from "../utils/data/contactData";
import payData from "../utils/data/payOptions";

const Footer = () => {
    const [t] = useTranslation("global");
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };
    return (
        <footer className="footer">
            <Container>
                <Row className="footer-row fr1">
                    <Col className="footer-ocean-logo" xs={12} lg={5}>
                        <img src={oceanLogo} alt="ocean logo" />
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nunc eget pretium mauris. Donec quis ipsum sit
                            amet sem rutrum tempus. Ut sed ligula ac tellus
                            feugiat lobortis
                        </p>
                        <ul className="footer-social-icons">
                            {socialData.map((i) => (
                                <li key={i.id} className="footer-social-icon">
                                    <a href={i.link}>
                                        <img src={i.icon} alt={i.title} />
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </Col>

                    <Col className="footer-list" xs={6} lg={2}>
                        <h5 className="footer-header">{t("footer.links")}</h5>
                        <ul>
                            {footerLinks.map((link) => (
                                <li
                                    key={link.id}
                                    className="footer-link"
                                    onClick={scrollToTop}
                                >
                                    <Link to={link.url}>{link.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </Col>

                    <Col className="footer-col-6" xs={6} lg={5}>
                        <Row className="footer-row fr11">
                            <Col className="footer-conatct" xs={12} lg={6}>
                                <h5 className="footer-header">
                                    {t("footer.contact")}
                                </h5>
                                <ul className="contact-ul">
                                    {contactData.map((i) => (
                                        <li key={i.id}>
                                            <a href={i.link}>
                                                <img
                                                    src={i.icon}
                                                    alt={i.title}
                                                />
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </Col>
                            <Col className="footer-dwnld-app" xs={12} lg={6}>
                                <h5 className="footer-header">
                                    {t("footer.shopinapp")}
                                </h5>
                                <a href="#">
                                    <img src={playstore} alt="google play" />
                                </a>
                                <a href="#">
                                    <img src={appstore} alt="appstore" />
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="footer-row fr2">
                    <div className="footer-pay-options">
                        <ul className="footer-pay-ul">
                            {payData.map((i) => (
                                <li key={i.id}>
                                    <a href={i.link}>
                                        <img src={i.icon} alt={i.title} />
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="rights-div">
                        <span>{t("footer.rights")}</span>
                        <span>|</span>
                        {/* <span>2023 Ocean store</span> */}
                    </div>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
